<form [formGroup]="zcvForm">
    <mat-form-field>
        <mat-select (selectionChange)="onChange($event.value)" placeholder="Zoning code" formControlName="zoningCode">
            <mat-option (change)="onChange($event)" *ngFor="let zoningCode of zoningCodes" [value]="zoningCode">
                {{zoningCode.Name}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-select placeholder="Zoning Code Version" [required]="true" formControlName="selectedZCVersion">
            <mat-option *ngFor="let zcVersion of zcVersions" [value]="zcVersion">
                Id: {{zcVersion.Id}}, Actual Version: {{zcVersion.ActualVersion}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</form>